import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { VatResource } from "@exonn/js-sdk";

export const module: Module<VatResource> = {
  id: ResourceEnum.Vat,
  bigIcon: <i className="icon-20-tax" />,
  smallIcon: <i className="icon-15-tax" />,
  name: (t: TFunction) => t("moduleName.vats"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
